/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { changeTrialPlanDataIntervalSchema } from './ChangeTrialPlanDataIntervalSchema'
import { changeTrialPlanDataTierSchema } from './ChangeTrialPlanDataTierSchema'

export const changeTrialPlanDataSchema = z.object({
	tier: changeTrialPlanDataTierSchema,
	interval: changeTrialPlanDataIntervalSchema,
})

export type ChangeTrialPlanDataSchema = z.infer<typeof changeTrialPlanDataSchema>
